import publicApiClient from '../publicApiClient';

/**
 * Service for public product operations
 */
export const publicProductService = {
    /**
     * Search products for a customer/supplier pair
     * @param {string} supplierId - Supplier public ID
     * @param {string} customerId - Customer public ID
     * @param {string} name - Optional search term
     * @param {number} page - Page number (0-indexed)
     * @param {number} size - Page size
     * @returns {Promise<{content: Array, totalElements: number, totalPages: number, size: number, number: number}>}
     */
    async searchProducts(supplierId, customerId, name = '', page = 0, size = 100) {
        const params = {
            supplierId,
            customerId,
            page,
            size
        };

        // Only add name if it's not empty
        if (name && name.trim()) {
            params.name = name.trim();
        }

        const response = await publicApiClient.get('/public/products/search', { params });
        return response.data;
    }
};
